export default "__VITE_ASSET__nJFqMlqn__"